import React from 'react'
import { Card, colors, H2, Separator } from '@fs/zion-ui'
import { type GroupSummary } from '@fs/zion-tree-types'
import { type GedcomFile, type GedcomFileFailed } from '../../../services/groupTypes'
import ManageTreeList from './ManageTreeList'
import UploadTreeButton from './UploadTreeButton'

type TableProps = {
  failedFiles?: GedcomFileFailed[]
  groups: GroupSummary[]
  isMobile: boolean
  processingFiles?: GedcomFile[]
  title?: string
  showUploadButton?: boolean
  isFamilyGroupTree?: boolean
}

function ManageTreesTable({
  failedFiles,
  groups,
  isMobile,
  processingFiles,
  title,
  showUploadButton,
  isFamilyGroupTree,
}: TableProps): JSX.Element {
  return (
    <Card margins="xs" edges="border" backgroundColor={colors.gray00}>
      {title && (
        <>
          <H2 size="H5">{title}</H2>
          <Separator size="xs" />
        </>
      )}
      <ManageTreeList
        processingFiles={processingFiles}
        groups={groups}
        failedFiles={failedFiles}
        isMobile={isMobile}
        isFamilyGroupTree={isFamilyGroupTree}
        showCombinedDesign
      />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      {showUploadButton && <UploadTreeButton emphasis="medium" />}
    </Card>
  )
}

export default ManageTreesTable
